require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-intermediate-algorithm-scripting-dna-pairing.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-intermediate-algorithm-scripting-dna-pairing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-intermediate-algorithm-scripting-dna-pairing!./.cache/json/javascript-algorithms-and-data-structures-intermediate-algorithm-scripting-dna-pairing.json
// module id = 2426
// module chunks = 231608221292675